module.exports = __webpack_public_path__ + "img/Vector.1a8a0eba.svg";